<template>
  <div :class="['side_tab_box', { active: show }]">
    <div class="side_tab_box_inner">
      <a
          class="close"
          :title="'Zavřít' | translate"
          @click.stop.prevent="show = false"
          v-translate>Zavřít
      </a>
      <form>
        <p class="side_tab_box_search">
          <search-input
              input-class="search"
              input-id="search-operator"
              :show-label="false"
              v-model="search"
              :input-placeholder="'Vyhledávání' | translate">
          </search-input>
        </p>
        <p class="check_all">
          <input
              id="checkAll"
              name="checkAll"
              type="radio"
              value="all-checked"
              :disabled="!isEditable"
              :checked="selectedOperatorId === null">
          <label for="checkAll" @click="changeOperator(null, null)" v-translate>Všichni operátoři</label>
        </p>
        <ul>
          <li v-for="operator in filteredOperatorsList" :key="operator.id">
            <input type="radio"
                   :id="'operator_select_'+operator.id"
                   :name="'operator_select_'+operator.id"
                   :value="operator.id"
                   :checked="selectedOperatorId === operator.id"
                   :disabled="!isEditable"
            >
            <label :for="'operator_select_'+operator.id" @click="changeOperator(operator.id, operator.name)">{{ operator.name }}</label>
          </li>
        </ul>
      </form>
    </div>
  </div>
</template>

<script>
import userSettings from "@/components/mixins/user-settings"
import message from "@/components/mixins/message"
import {filterEntities} from "@/utils/helpers"

export default {
  name: "OperatorCheckboxes",
  mixins: [userSettings, message],

  data() {
    return {
      operatorsList: [],
      selectedOperatorId: null,
      search: '',
      show: false,
    }
  },

  created(OperatorService) {
    this.operatorService = OperatorService

    if (this.$_loggedUser_canChangeOperator) {
      this.operatorService.getOperators()
          .then(data => {
            this.operatorsList = data.operators
            this.selectedOperatorId = this.$store.getters.getSelectedOperatorId;
          });
    }
  },

  computed: {
    filteredOperatorsList() {
     return this.search.length > 0
         ? filterEntities({...this.operatorsList}, ['name'], this.search)
         : this.operatorsList;
    },
    isEditable(){
      return this.$_loggedUser_canChangeOperator;
    }
  },

  methods: {
    changeOperator(idOperator, nameOperator){
      this.selectedOperatorId = idOperator;
      this.setOwnerSetting('selected-operator-id', this.selectedOperatorId);
      this.setOwnerSetting('selected-operator-name', nameOperator);
      this.resetUserSettings();
      this.$emit('operatorChanged', this.selectedOperatorId);
    },
    toggleShow(){
      this.show = !this.show;
    },
    hide(){
      this.show = false;
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/OperatorCheckboxes.vue